(function () {
  'use strict';

  function readJson(root, selector, fallback) {
    var el = root.querySelector(selector);
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function initHairQuiz(root) {
    var q1Label = readJson(root, '[data-hq-q1-label]', 'Vad har du för hårproblem?');
    var problems = readJson(root, '[data-hair-quiz-data]', []);
    var heatQuestion = readJson(root, '[data-hq-heat-question]', { label: '', options: [], trigger_options: [] });

    var heatProduct = {
      title: root.getAttribute('data-heat-product-title') || '',
      price: root.getAttribute('data-heat-product-price') || '',
      description: root.getAttribute('data-heat-product-description') || '',
      variantId: root.getAttribute('data-heat-product-variant-id') || ''
    };

    var totalSteps = 5; // q1 + 3 branch questions + heat question
    var step = 1;
    var selectedProblem = null;
    var answers = [];

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    function renderProgress() {
      var dots = '';
      for (var i = 1; i <= totalSteps; i++) {
        dots += '<div class="hq-progress__dot' + (i <= step ? ' is-complete' : '') + '"></div>';
      }
      return '<div class="hq-progress">' + dots + '</div>';
    }

    function renderQuestion(label, options, onSelect) {
      root.innerHTML =
        renderProgress() +
        '<p class="hq-step-label">Fråga ' + step + ' av ' + totalSteps + '</p>' +
        '<h3 class="hq-question">' + escapeHtml(label) + '</h3>' +
        '<div class="hq-options" data-hq-options></div>';

      var container = root.querySelector('[data-hq-options]');
      options.forEach(function (label) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hq-option';
        btn.textContent = label;
        btn.addEventListener('click', function () {
          onSelect(label);
        });
        container.appendChild(btn);
      });
    }

    function renderStep1() {
      var options = problems.map(function (p) {
        return p.label;
      });
      renderQuestion(q1Label, options, function (label) {
        selectedProblem = problems.filter(function (p) {
          return p.label === label;
        })[0] || null;
        answers = [];
        step = 2;
        renderBranchQuestion(0);
      });
    }

    function renderBranchQuestion(index) {
      if (!selectedProblem || !selectedProblem.questions || !selectedProblem.questions[index]) {
        // No question configured for this slot, skip forward
        if (index < 2) {
          step++;
          renderBranchQuestion(index + 1);
        } else {
          step = 5;
          renderHeatQuestion();
        }
        return;
      }

      var q = selectedProblem.questions[index];
      renderQuestion(q.label, q.options, function (value) {
        answers[index] = value;
        if (index < 2) {
          step++;
          renderBranchQuestion(index + 1);
        } else {
          step = 5;
          renderHeatQuestion();
        }
      });
    }

    function renderHeatQuestion() {
      renderQuestion(heatQuestion.label, heatQuestion.options, function (value) {
        var showHeat = (heatQuestion.trigger_options || []).indexOf(value) !== -1;
        renderResult(showHeat);
      });
    }

    function renderResult(showHeat) {
      var collectionName = selectedProblem ? selectedProblem.collection_name : 'din hårtyp';
      var collectionUrl = selectedProblem ? selectedProblem.url : '#';

      var html =
        '<p class="hq-step-label">Ditt resultat</p>' +
        '<h3 class="hq-result-heading">Baserat på dina svar rekommenderar vi</h3>' +
        '<div class="hq-card">' +
          '<div class="hq-card__top">' +
            '<div class="hq-card__icon">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2l1.5 5.5L19 9l-5.5 1.5L12 16l-1.5-5.5L5 9l5.5-1.5z"/></svg>' +
            '</div>' +
            '<div>' +
              '<p class="hq-card__title">' + escapeHtml(collectionName) + '</p>' +
              '<p class="hq-card__meta">Rekommenderad kollektion</p>' +
            '</div>' +
          '</div>' +
          '<a class="hq-button" href="' + escapeHtml(collectionUrl) + '">Se produkter</a>' +
        '</div>';

      if (showHeat && heatProduct.variantId) {
        html +=
          '<div class="hq-card hq-card--heat">' +
            '<div class="hq-card__top">' +
              '<div class="hq-card__icon">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2c-1.5 3-4 4-4 8a4 4 0 008 0c0-1-.5-2-1-2.5.3 1 0 2-1 2.5.3-1.5-.5-2.5-1-3.5-.5 1-1 1.5-1 2 0-2 .5-4 0-6.5z"/></svg>' +
              '</div>' +
              '<div>' +
                '<p class="hq-card__title">' + escapeHtml(heatProduct.title) + '</p>' +
                '<p class="hq-card__meta">' + escapeHtml(heatProduct.price) + ' — eftersom du använder värmeverktyg</p>' +
              '</div>' +
            '</div>' +
            '<p class="hq-card__desc">' + escapeHtml(heatProduct.description) + '</p>' +
            '<button type="button" class="hq-button" data-hq-add-to-cart>Lägg i varukorgen</button>' +
            '<p class="hq-cart-status" data-hq-cart-status></p>' +
          '</div>';
      }

      html += '<button type="button" class="hq-restart" data-hq-restart>Börja om quizet</button>';

      root.innerHTML = html;

      var addBtn = root.querySelector('[data-hq-add-to-cart]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addToCart(heatProduct.variantId, addBtn, root.querySelector('[data-hq-cart-status]'));
        });
      }

      root.querySelector('[data-hq-restart]').addEventListener('click', function () {
        selectedProblem = null;
        answers = [];
        step = 1;
        renderStep1();
      });
    }

    function addToCart(variantId, button, statusEl) {
      button.disabled = true;
      button.textContent = 'Lägger till...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function () {
          button.textContent = 'Tillagd i varukorgen ✓';
          if (statusEl) statusEl.textContent = '';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = 'Lägg i varukorgen';
          if (statusEl) statusEl.textContent = 'Något gick fel, försök igen.';
        });
    }

    renderStep1();
  }

  function init() {
    var roots = document.querySelectorAll('[data-hair-quiz]');
    roots.forEach(initHairQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();